import React, { useState } from 'react';

import {
  Box,
  Collapse,
  IconButton,
  makeStyles,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  Fab,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
} from '@material-ui/core';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@material-ui/icons/KeyboardArrowUp';
import { DeleteOutline } from '@material-ui/icons';
import { useDispatch } from 'react-redux';
import { pasarErrorEvolucionGeneralOdonto } from '../../../../actions/hce/hceActions';

const useStyles = makeStyles({
  iconEstado: {
    '&:hover': {
      backgroundColor: '#80808026',
    },
  },
});

const optionsfecha = {
  year: 'numeric',
  month: '2-digit',
  day: '2-digit',
};

export const EvolucionesGeneralesHistorialItem = (props) => {
  const classes = useStyles();
  const dispatch = useDispatch();

  const [openEvolucionInfo, setOpenMeEvolucionInfo] = useState(false);
  const [confirmOpen, setConfirmOpen] = useState(false);
  const { evolucion, hce } = props;

  const handleDelete = () => {
    setConfirmOpen(!confirmOpen);
  };

  return (
    <React.Fragment>
      <TableRow className={classes.iconEstado}>
        <TableCell>{evolucion?.nombreEfector}</TableCell>
        <TableCell>
          {new Date(evolucion?.fecha).toLocaleString('es', optionsfecha)}
        </TableCell>
        <TableCell>
          {evolucion?.evolucion?.length > 0 && (
            <IconButton
              aria-label="expand row"
              size="small"
              onClick={() =>
                setOpenMeEvolucionInfo(
                  (prevOpenMedicamentoInfo) => !prevOpenMedicamentoInfo,
                )
              }
            >
              {openEvolucionInfo ? (
                <KeyboardArrowUpIcon />
              ) : (
                <KeyboardArrowDownIcon />
              )}
            </IconButton>
          )}
        </TableCell>
      </TableRow>
      <TableRow>
        <TableCell
          style={{
            paddingBottom: 0,
            paddingTop: 0,
            paddingLeft: 50,
          }}
          colSpan={8}
        >
          <Collapse in={openEvolucionInfo} timeout="auto" unmountOnExit>
            <Box margin={1}>
              <Table size="small" aria-label="purchases">
                <TableHead>
                  <TableRow>
                    <TableCell>Evolucion</TableCell>
                    <TableCell>Borrar</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  <TableCell>{evolucion?.evolucion}</TableCell>
                  {evolucion?.idEfectorRed === hce.idEfector && (
                    <TableCell>
                      <Fab
                        color="primary"
                        aria-label="add"
                        size="small"
                        onClick={handleDelete}
                      >
                        <DeleteOutline />
                      </Fab>
                      <Dialog open={confirmOpen} onClose={handleDelete}>
                        <DialogTitle>Mensaje</DialogTitle>
                        <DialogContent>
                          <p>
                            ¿Estás seguro de que deseas pasar a error el
                            problema?
                          </p>
                        </DialogContent>
                        <DialogActions>
                          <Button
                            variant="contained"
                            color="secondary"
                            onClick={() => {
                              const data = {
                                id: evolucion.id,
                              };
                              dispatch(
                                pasarErrorEvolucionGeneralOdonto(
                                  data,
                                  hce.idAfiliado,
                                  hce.idAfiliadoExterno
                                ),
                              );
                              setConfirmOpen(false);
                            }}
                          >
                            Sí
                          </Button>
                          <Button
                            variant="contained"
                            color="primary"
                            onClick={handleDelete}
                          >
                            No
                          </Button>
                        </DialogActions>
                      </Dialog>
                    </TableCell>
                  )}
                </TableBody>
              </Table>
            </Box>
          </Collapse>
        </TableCell>
      </TableRow>
    </React.Fragment>
  );
};
